import React from "react";
import { useI18n } from "@core/i18n/i18n";
import EmptyBoxIcon from "@assets/icons/empty-box-large.svg";
import { MessageContainer } from "@ui/components/common/message-container";

export const EmptyTemplatesSearch: React.FC = () => {
	const { format } = useI18n();

	return (
		<MessageContainer
			style={{ flexGrow: 1, padding: "72px 32px" }}
			iconSvg={EmptyBoxIcon}
			title={format("templateListing.templates.emptySearch.title")}
			description={format("templateListing.templates.emptySearch.description")}
		/>
	);
};
